import { COMMERCIAL_ENDPOINTS } from '../../../../../../utils/api/endpoints/commercialEndpoints';
import {
  SearchCommerciauxQuery,
  SearchCommerciauxQueryResponse,
} from './DashboardCommerciauxTable.types';

const SEARCH_PREFIX = '[searchCommerciauxQuery]';

export const SEARCH_COM_QUERY_KEY = 'SEARCH_COM';

export const searchCommerciauxQuery = async ({
  search,
  params: { page = 1, perPage = 25, enabled, department },
}: SearchCommerciauxQuery) => {
  console.log(SEARCH_PREFIX, `Fetching search commerciaux...`);
  const response = await COMMERCIAL_ENDPOINTS.search(search, {
    page,
    perPage,
    enabled,
    department,
  });

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(SEARCH_PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(SEARCH_PREFIX, `Fetched search commerciaux.`);
  return json as SearchCommerciauxQueryResponse;
};
